import gql from 'graphql-tag'

export const fetchRecommendedListQuery = gql`
query ($shipTo: String, $selectedItem: String, $cartItems: [CartItemsInput]) {
  recommendItems(
    shipTo: $shipTo
    selectedItem: $selectedItem
    cartItems: $cartItems
  ) {
    shipTo
    recItems {
      productId
      Priority
      name
      catalog_product_name
      high_markets_discount
      material_type
      your_price
      favourites
      product_last
      product_new
      packaging_enable
      number_of_bottles_gabbie
      product_sale
      product_seasonal
      product_recommended
      number_of_products_on_layer
      number_of_items_on_pallet,
      number_of_layers_per_pallet
      small_image
      tags {
        value
        label
        color
      }
      cart_fields {
        packaging_cart
        layer_cart
        pallets_cart
      }
      __typename
    }
  }
}
`
